import { apiUrl } from "../../constants";
import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getCustomerDrafts = createAsyncThunk(
  "integrations/getCustomerDrafts",
  async (data, thunkAPI) => {
    const state = thunkAPI.getState();
    const token = state.user.token;

    const queryParams = new URLSearchParams();

    if (data.page) queryParams.append("page", data.page);

    const requestOptions = {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    try {
      const response = await fetch(
        `${apiUrl}/get_customer_drafts?${queryParams.toString()}`,
        requestOptions
      );

      if (!response.ok) {
        let errorMessage = "Network response was not ok";
        try {
          const errorText = await response.text();
          const errorObj = JSON.parse(errorText);
          errorMessage = errorObj.error || errorMessage;
        } catch (e) {
          errorMessage = errorText || errorMessage;
        }
        throw new Error(errorMessage || "Unknown error occurred");
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error("Fetching customer drafts failed:", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const getCustomerDraftsSlice = createSlice({
  name: "integrations",
  initialState: {
    customers: [],
    filtered_count: null,
    total_count: null,
    status: "idle", // 'idle' | 'loading' | 'success' | 'error'
    error: null,
  },
  reducers: {
    resetCetCustomerDraftsState(state) {
      state.customers = [];
      state.filtered_count = null;
      state.total_count = null;
      state.status = "idle";
      state.error = null;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getCustomerDrafts.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getCustomerDrafts.fulfilled, (state, action) => {
        state.customers = action.payload.customers || action.payload.data;
        state.filtered_count = action.payload.filtered_count;
        state.total_count = action.payload.total_count;
        state.status = "success";
        state.error = null;
      })
      .addCase(getCustomerDrafts.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
        state.customers = [];
      });
  },
});

export const { resetCetCustomerDraftsState } = getCustomerDraftsSlice.actions;
export default getCustomerDraftsSlice.reducer;
